import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
    initialState: {
        codeVerifier: null as string | null,
        state: null as string | null
    },

    name: 'useOAuth2',

    reducers: {
        codeVerifier: (state, action) => {
            state.codeVerifier = action.payload;
        },

        state: (state, action) => {
            state.state = action.payload;
        }
    }
});

export default slice.reducer;
